import { logger } from '@playbooks/utils';

import { workspaceQuery } from 'queries/workspace-queries';
import { hasAuthCookie } from 'utils/auth';

type SettingsQueryContext = {
	req: any;
	params?: any;
	query?: any;
};

type SettingsQuery = (context: SettingsQueryContext) => Promise<any>;

type WorkspaceSettingsQueryOptions = {
	loaders?: Record<string, SettingsQuery>;
	capability?: string;
};

const workspaceSettingsQuery = async (context: SettingsQueryContext, options: WorkspaceSettingsQueryOptions = {}) => {
	if (!hasAuthCookie(context.req.cookies)) return { redirect: { destination: '/auth' } };

	const queryContext = { ...context, params: context.params || {}, query: context.query || {} };
	const workspace = await workspaceQuery(queryContext);
	const capabilities = workspace.data?.access?.capabilities;
	const capabilitiesAvailable = Boolean(capabilities);
	const authorized = options.capability ? Boolean(capabilities?.[options.capability]) : true;
	if (!capabilitiesAvailable)
		logger.error('workspaceSettingsQuery: workspace access capabilities are missing', {
			workspaceId: workspace.data?.id,
			workspaceType: workspace.data?.type,
		});

	const entries = authorized ? Object.entries(options.loaders || {}) : [];
	const records = await Promise.all(entries.map(([, loader]) => loader(queryContext)));
	const props = entries.reduce((result, [key], index) => ({ ...result, [key]: records[index] }), { workspace });

	return {
		props: {
			...props,
			pageAccess: { authorized, capabilitiesAvailable, capability: options.capability || null },
			workspaceType: workspace.data?.type,
		},
	};
};

export { workspaceSettingsQuery };
